import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const syncFG = async (type: string) => {
  const { data } = await apiInputService.get(`/Fieldglass/sync/${type}`);

  return data;
};

export const useSyncFieldglass = (options?: any) => {
  return useMutation(syncFG, {
    ...options,
  });
};
